module.exports = __webpack_public_path__ + "img/gift-content-ms.c6f17462.png";